import { compose, withHandlers, withProps } from 'recompose'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import withTrailerFlags from 'components/common/hoc/withTrailerFlags'
import withShowConfirmTireSizeModalPreconfigured from 'components/common/hoc/withShowConfirmTireSizeModalPreconfigured'
import VehicleSection from './VehicleSection'
import { resetSubmittedTireSize } from 'components/VehicleConfigurator/components/withTireSize/actions'
import { actions } from '../VehicleDeleteModal/index'
import { openVehicleEditor } from './actions'
import { VEHICLE_DETAILS_URL, NOT_ACTIVE_VEHICLE_QUERY_PARAMS } from 'components/MyGarage2.0/constants'
import { showEditMileageModal } from 'components/VehicleDetails/actions'
import { getCurrentStoreIsE2EAppointment } from 'selectors/getCurrentStore'

const { showVehicleDeleteModal } = actions

const mapStateToProps = (state) => ({
  isE2EAppointment: getCurrentStoreIsE2EAppointment(state)
})

const mapDispatchToProps = (dispatch, { userVehicleId }) => ({
  openVehicleEditModal() {
    dispatch(openVehicleEditor({ userVehicleId }))
  },
  openVehicleDeleteModal() {
    dispatch(showVehicleDeleteModal({ userVehicleId }))
  },
  openEditMileageModal() {
    dispatch(showEditMileageModal({ userVehicleId }))
  },
  resetSubmittedTireSize
})

const withFormattedSize = withProps(({ tireFrontSize, tireRearSize, isGenericTrailer, isTrailer }) => ({
  formattedTireSize: tireRearSize ? `Front: ${tireFrontSize} Rear: ${tireRearSize}` : tireFrontSize,
  isTrailerOrGenericTrailer: isGenericTrailer || isTrailer
}))

const withNavigateToVehicleDetailsPageHandler = withHandlers({
  navigateToVehicleDetailsPage: ({ handleUseThisVehicleClick, history, isActiveVehicle }) => e => {
    e.preventDefault()
    const URL = !isActiveVehicle ? `${VEHICLE_DETAILS_URL}?${NOT_ACTIVE_VEHICLE_QUERY_PARAMS}` : VEHICLE_DETAILS_URL
    handleUseThisVehicleClick()
    history.push(URL)
  }
})

const withVehicleHandlers = withHandlers({
  handleViewCartClick: ({ makeActiveVehicle, userVehicleId, urlLinkToViewCart }) => event => {
    event.preventDefault()

    return makeActiveVehicle({ userVehicleId, url: urlLinkToViewCart })
  },
  handleViewSearchClick: ({
    makeActiveVehicle,
    userVehicleId,
    searchTiresUrl,
    triggerConfirmTireSizeModal,
    formattedSize,
    masterVehicle = {}
  }) => event => {
    event.preventDefault()
    return makeActiveVehicle({
      userVehicleId,
      masterVehicle,
      triggerConfirmTireSizeModal,
      url: searchTiresUrl,
      showConfirmTireSizeModal: !formattedSize
    })
  },
  handleViewSearchByTireSizeClick: ({ resetSubmittedTireSize }) => event => {
    resetSubmittedTireSize()
  },
  handleUseThisVehicleClick: ({ makeActiveVehicle, userVehicleId, urlLinkToViewCart }) => () =>
    makeActiveVehicle({ userVehicleId })
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTrailerFlags,
  withRouter,
  withShowConfirmTireSizeModalPreconfigured,
  withVehicleHandlers,
  withNavigateToVehicleDetailsPageHandler,
  withFormattedSize
)(VehicleSection)

